import * as React from "react";

function RefreshCW(props) {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 5.333c3.192 0 5.929 1.439 7.743 4h-5.076V12H28V2.667h-2.667v4.36c-2.3-2.784-5.594-4.36-9.333-4.36C8.636 2.667 2.667 8.637 2.667 16h2.666C5.333 10.109 10.11 5.333 16 5.333zm0 21.334c-3.191 0-5.928-1.439-7.742-4h5.075V20H4v9.333h2.667v-4.36c2.3 2.784 5.594 4.36 9.333 4.36 7.364 0 13.333-5.97 13.333-13.333h-2.666c0 5.891-4.776 10.667-10.667 10.667z"
      />
    </svg>
  );
}

export default RefreshCW;
